import {isNil, omitBy} from 'lodash';

export const omitByNilObject = (obj: {[key: string]: any}) => {
  return omitBy(obj, isNil);
};

export const getArrayDepth = (array: any[] | any): number =>
  Array.isArray(array) ? 1 + Math.max(0, ...array.map(getArrayDepth)) : 0;
